import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginPage from "./modules/auth/pages/LoginPage";
import SignUpPage from "./modules/auth/pages/SignUpPage";
import PDFReader from "./modules/PDFReader/PDFReader";
import Landing from "./modules/Landing/components/Landing";
import Dashboard from "./modules/dashboard/components/Dashboard";
import SelectCompany from "./modules/company/components/SelectCompany";
import NewCompany from "./modules/company/components/NewCompany";
import DashboardCompany from "./modules/company/components/DashboardCompany";
import DetailsCompany from "./modules/company/pages/DetailsCompany";
import EditCompany from "./modules/company/pages/EditCompany";
import BillingList from "./modules/billing/components/billingList";
import NewBill from "./modules/billing/components/newBill";
import BillCreate from "./modules/billing/pages/BillCreate";
import ProtectedRoute from "./modules/auth/components/RutasProtegidas";
import AppLayout from "./modules/shared/components/AppLayout";
import ContractsPage from "./modules/contracts/pages/ContractsPage";

import { Layout, theme } from "antd";
import "./App.css";
import UploadContract from "./modules/contracts/pages/UploadContract";
import NotFoundPage from "./modules/shared/components/NotFoundPage";
import DashboardCatalogs from "./modules/catalogs/pages/DashboardCatalogs";
import Providers from "./modules/providers/pages/Providers";
import NewProvider from "./modules/providers/pages/NewProvider";
import Clients from "./modules/clients/pages/Clients";
import NewClient from "./modules/clients/pages/NewClient";
import Concepts from "./modules/concepts/pages/Concepts";
import NewConcept from "./modules/concepts/pages/NewConcept";
import Products from "./modules/products/pages/Products";
import NewProduct from "./modules/products/pages/NewProduct";
import ChartAccounts from "./modules/chart_accounts/pages/ChartAccounts";

import QuotesPage from "./modules/quotes/pages/QuotesPage";
import NewQuote from "./modules/quotes/pages/NewQuote";
import { useHybridResponsive } from "./modules/shared";

const defaultClass =
  "max-w-md lg:max-w-2xl xl:max-w-4xl mx-auto py-8 flex items-center justify-center min-h-screen";

//   backgroundColor: token.colorBgLayout,
function App() {
  const { token } = theme.useToken();
  const { isMobile } = useHybridResponsive();

  return (
    <Layout
      style={{
        margin: "0 auto",
        minHeight: "100vh",
        background: token.colorBgLayout,
        fontFamily: "'Manrope', sans-serif",
        paddingBottom: isMobile ? "64px" : "0",

      }}
    >
      <BrowserRouter basename={`${BASE_PATH}`}>
        <Routes>
          <Route
            path="/login"
            element={
              <div className={defaultClass}>
                <LoginPage />
              </div>
            }
          />
          <Route
            path="/signUp"
            element={
              <div className={defaultClass}>
                <SignUpPage />
              </div>
            }
          />
          <Route
            path="/pdfReader"
            element={
              <div className={defaultClass}>
                <PDFReader />
              </div>
            }
          />
          <Route path="/" element={<Landing />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/facturas" element={<BillingList />} />
              <Route path="/facturas/subir" element={<NewBill />} />
              <Route path="/facturas/nueva" element={<BillCreate />} />
              <Route path="/empresa/dashboard" element={<DashboardCompany />} />
              <Route path="/empresa/select" element={<SelectCompany />} />
              <Route path="/empresa/detalles" element={<DetailsCompany />} />
              <Route path="/empresa/nueva" element={<NewCompany />} />
              <Route path="/empresa/editar" element={<EditCompany />} />
              <Route path="/contratos" element={<ContractsPage />} />
              <Route path="/contrato/nuevo" element={<UploadContract />} />
              <Route path="/cotizaciones" element={<QuotesPage />} />
              <Route path="/cotizacion/nueva" element={<NewQuote />} />

              <Route path="/catalogos" element={<DashboardCatalogs />} />
              <Route path="/catalogo/proveedores" element={<Providers />} />
              <Route path="/catalogo/proveedores/nuevo" element={<NewProvider />} />
              <Route path="/catalogo/clientes" element={<Clients />} />
              <Route path="/catalogo/clientes/nuevo" element={<NewClient />} />
              <Route path="/catalogo/conceptos" element={<Concepts />} />
              <Route path="/catalogo/conceptos/nuevo" element={<NewConcept />} />
              <Route path="/catalogo/productos" element={<Products />} />
              <Route path="/catalogo/productos/nuevo" element={<NewProduct />} />
              <Route path="/catalogo/plan_cuentas" element={<ChartAccounts />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </Layout>
  );
}

export default App;
